import { DeactivationReason } from './../../../core/types/enums';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { Resident } from '../../models/resident.model';
import { CommonModule } from '@angular/common';
import { InactiveResidentMessageComponent } from '../inactive-resident-message/inactive-resident-message.component';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-inactive-resident-modal',
  templateUrl: './inactive-resident-modal.component.html',
  styleUrls: ['./inactive-resident-modal.component.scss'],
  imports: [
    MatIconModule,
    MatDialogModule,
    CommonModule,
    InactiveResidentMessageComponent,
    ModalCloseButtonComponent,
  ],
})
export class InactiveResidentModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { resident: Resident },
    private dialogRef: MatDialogRef<InactiveResidentModalComponent>
  ) {}

  DeactivationReason = DeactivationReason;

  closeDialog() {
    this.dialogRef.close();
  }
}
